<template>
  <div class="voting-count-container">
    <custom-skeleton-loader :LoadingFlag="SkeletonLoadingFlag" />
    <div v-if="!SkeletonLoadingFlag" class="voting-content">
      <div class="voting-card">
        <div class="voting-icon">
          <v-icon>mdi-hand-right</v-icon>
        </div>
        <div class="voting-body">
          <div class="voting-label">Voting Count</div>
          <div class="voting-number">{{ VotingData.VotingCount }}</div>
          <div class="voting-actions">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small v-bind="attrs" v-on="on" @click="editData" class="info-btn">
                  <v-icon>mdi-information-outline</v-icon>
                </v-btn>
              </template>
              <span>View Details</span>
            </v-tooltip>
          </div>
          <div>
            <v-chip v-if="VotingData.LoStatusTxt" class="mt-2" label small :style="{
              backgroundColor: VotingData.LoStatusColor,
              color: '#fff',
              fontWeight: '600',
            }">
              {{ VotingData.LoStatusTxt }}
            </v-chip>
          </div>
        </div>
      </div>

      <v-dialog v-model="EditRecordPrompt" persistent max-width="70%">
        <voting-description v-if="EditRecordPrompt" :recordData="VotingData"
          @hideDialog="hideAddRecordPrompt"></voting-description>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import VotingDescription from "@/view/pages/erp/lom/lom-information/VotingDescription.vue";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {
    VotingDescription,
  },
  props: {
    LomCode: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      VotingRightsStatus: "",
      DocumentPath: "",
      EditRecordPrompt: false,

      SkeletonLoadingFlag: true,

      EligibleCount: 0,
      selectedData: {},
      VotingData: {},

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",

      RoleId: "",
    };
  },
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");

      var RoleId = this.$session.get("RoleId");
      this.RoleId = RoleId == (null || undefined) ? "" : RoleId;
      console.log({ RoleId: this.RoleId });
    },
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;

      var RoleId = this.$session.get("RoleId");
      this.RoleId = RoleId == (null || undefined) ? "" : RoleId;

      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "voting_rights",
        Action: "list",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
      this.pageData();
    },
    pageData() {
      console.log("pageData called");
      this.eligibleMembershipCount();
    },
    hideAddRecordPrompt() {
      console.log("hideAddRecordPrompt called");
      this.EditRecordPrompt = false;
    },
    editData() {
      console.log("editData called");
      var tr = this.VotingData;
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));

      if (n1 > 0) {
        this.EditRecordPrompt = true;
        this.selectedData = tr;
      } else {
        var message = "Votingdescription failed";
        this.toast("error", message);
      }
    },
    editData() {
      console.log("editData called");
      var tr = this.VotingData;
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));

      if (n1 > 0) {
        this.EditRecordPrompt = true;
        this.selectedData = tr;
      } else {
        var message = "Votingdescription failed";
        this.toast("error", message);
      }
    },
    eligibleMembershipCount() {
      console.log("eligibleMembershipCount called");

      this.SkeletonLoadingFlag = true;

      console.log({ "RoleId  he": this.RoleId });
      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/lom-payment/eligible-count";
      var upload = {
        UserInterface: this.RoleId == 1 || this.RoleId == 2 || this.RoleId == 4 ? 2 : 1,
        Lom: this.LomCode,
      };
      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      const thisIns = this;
      var output = "";
      var flag = 0;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          thisIns.SkeletonLoadingFlag = false;

          output = response.data.output;
          flag = response.data.flag;
          console.log("output=" + output + ", flag=" + flag);

          if (flag) {
            var records = response.data.records;
            console.log("records=" + JSON.stringify(records));
            thisIns.VotingData = records;
            console.log("VotingData=" + JSON.stringify(thisIns.VotingData));
            // thisIns.toast("success", output);
          } else {
            thisIns.VotingRightsStatus = "Not completed";
            // thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.SkeletonLoadingFlag = false;
        });
    },
  },
  mounted() { },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>

<style lang="scss" scoped>
.voting-count-container {
  width: 100%;
  height: 100%;

  .voting-content {
    padding: 0;
    height: 100%;
  }

  .voting-card {
    display: flex;
    align-items: flex-start;
    gap: 20px;
    padding: 24px;
    background: linear-gradient(135deg, #fff9c4 0%, #fffde7 100%);
    border-radius: 14px;
    border: 2px solid #edbe38;
    position: relative;
    overflow: hidden;
    height: 100%;

    &::before {
      content: "";
      position: absolute;
      top: -50%;
      right: -50%;
      width: 200%;
      height: 200%;
      background: radial-gradient(circle,
          rgba(255, 255, 255, 0.1) 0%,
          transparent 70%);
      animation: float 6s ease-in-out infinite;
    }
  }

  .voting-icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    background: linear-gradient(135deg, #edbe38 0%, darken(#edbe38, 10%) 100%);
    border-radius: 12px;
    color: white;
    font-size: 28px;
    position: relative;
    z-index: 1;
  }

  .voting-body {
    flex: 1;
    position: relative;
    z-index: 1;
  }

  .voting-label {
    font-size: 12px;
    font-weight: 700;
    color: #414042;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    margin-bottom: 8px;
  }

  .voting-number {
    font-size: 48px;
    font-weight: 900;
    color: #0a0f29;
    line-height: 1;
    margin-bottom: 12px;
  }

  .voting-actions {
    display: flex;
    gap: 8px;
  }

  .info-btn {
    background: linear-gradient(135deg,
        #3a67b1 0%,
        darken(#3a67b1, 5%) 100%) !important;
    color: white !important;
    transition: all 0.3s ease !important;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(58, 103, 177, 0.3);
    }
  }

  @keyframes float {

    0%,
    100% {
      transform: translateY(0px);
    }

    50% {
      transform: translateY(-12px);
    }
  }
}

.v-sheet--offset {
  top: -24px;
  position: relative;
}

.v-dialog {
  display: none;
}

.vertical {
  border-left: 1px solid black;
  height: 140px;
  position: absolute;
  left: 50%;
}

.font {
  font-size: 50px;
  margin-left: 120px;
}
</style>